import { render, staticRenderFns } from "./StudioGenre.vue?vue&type=template&id=99809f10&scoped=true&"
import script from "./StudioGenre.vue?vue&type=script&lang=js&"
export * from "./StudioGenre.vue?vue&type=script&lang=js&"
import style0 from "./StudioGenre.vue?vue&type=style&index=0&id=99809f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99809f10",
  null
  
)

component.options.__file = "StudioGenre.vue"
export default component.exports